<div [formGroup]="getFormGroup()" [class]="getStyleClass()">

<label class="control-label bs-label th-text-main fw-bold" [class.bar-filter-label-margin]="getOneLineControl()">{{getLabelValue()}} <span class="required-span" *ngIf="getRequired()">*</span></label>

<div  
       [class.oneline-control-div]="getOneLineControl()" 
       [class.pull-right]="getOneLineControl()"
       [class.input-group-width]="getReadOnly()"
       class="input-group bs-input-div th-bg-input th-input-border"
       [class.th-input-alert]="!this.getIsValid()"
       >

       <input [id]="getId()"
       [thousandSeparator]="thousandSeparator"
       [prefix]="prefix"
       [suffix]="suffix"
       [mask]="mask"
       [name]="getModelId()"
       [formControlName]="getModelId()"
       #el
       type="text"
       class="form-control bs-input-complete bs-input th-bg-input th-text-dark-gray"
       [class.th-bg-input-alert]="!this.getIsValid()"
       [class.col-sm-10]="getOneLineControl()"
       [class.pull-right]="getOneLineControl()"
       [class.form-control-read-only]="getReadOnly()" 
       [required]="getRequired()"
       [disabled]="getReadOnly()"
       [class.th-bg-disabled]="getReadOnly()"
       [max]="getMax()"
       (keyup.enter) = "onEnter()"
       (keyup) = "onKeyUp($event)"
       [min]="getMin()"
       (click)="event2('onClick');onClick()"
       [placeholder]="getPlaceHolder()"
       [title]="getTooltipMessage()?getTooltipMessage():''" 
       
       [style]="'text-align:' + getTextOrientation()"/>

      
       <!-- It's container of the icon of the inputs. -->
       <div class="bs-icon-div th-bg-input"
            *ngIf="this.getInputIcon().length > 0">
              <span class="input-group-text bs-icon th-bg-input"
              [class.th-bg-input-alert]="!this.getIsValid()"
              [class.th-bg-disabled]="getReadOnly()">
                     <i class="{{this.getInputIcon()}}"></i>
              </span>
       </div>
</div>
<!--  *ngIf="el.errors?.required && el.touched" -->
<small class="help-block text-danger bs-error th-text-alert" 
       [class.col-sm-10]="getOneLineControl()" 
       [class.pull-right]="getOneLineControl()" 
       *ngIf="!this.getIsValid()">
       <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
       {{getRequiredMessage()}}</small>
</div>
